import { UPDATE_DIALOG_PORTALS } from './index';

export const updateDialogPortalsAction = (portals) => ({
    type: UPDATE_DIALOG_PORTALS,
    portals
});